import { Proxy } from "../../services/proxy/proxy.service";
import { APIOnLine } from "../../services/api/api.services";
import { AlineacionPage } from "../../pages/alineacion/alineacion";
import { CustodiaPage } from "../../pages/custodia/custodia";
import {
  App,
  Nav,
  ToastController,
  ActionSheetController,
  ActionSheet,
} from "ionic-angular";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { ResultadoPage } from "../../pages/resultado/resultado";
import { ParticipacionPage } from "../../pages/participacion/participacion";
import { CambiosPage } from "../../pages/cambios/cambios";
import { GolesPage } from "../../pages/goles/goles";
import { AmonestacionesPage } from "../../pages/amonestaciones/amonestaciones";
import { QuintetoPage } from "../../pages/quinteto/quinteto";
import { TiempoMuertoPage } from "../../pages/tiempo-muerto/tiempo-muerto";
import { iConfiguracion } from "../basePage";
import { IncidenciasPage } from "../../pages/incidencias/incidencias";
import { FinalizarPage } from "../../pages/finalizar/finalizar";
import { ResumenPage } from "../../pages/resumen/resumen";
import { Online } from "./cfutbol";
import { LoginPage } from "../../pages/login/login";
import { ProyectoGanarService } from "../../services/api/ganar.services";
import { LesionadosPage } from "../../pages/lesionados/lesionados";

export module Navegacion {
  export interface iMenuDerechoNavegacion {
    esIncidencia?: boolean;
    idEquipo: number;
    final?: boolean;
    pagina: any;
    titulo: string;
  }

  /**
   * Clase destinada a gestionar la navegación por la aplicación.
   */
  export class Navegar {
    private nav: Nav;

    public paginas: Array<iMenuDerechoNavegacion> = [];

    constructor(
      public actionSheetCtrl: ActionSheetController,
      public appCtrl: App,
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public proyectoGanarService: ProyectoGanarService,
      public toastCtrl: ToastController
    ) {
      this.nav = this.appCtrl.getRootNav();

      this.CreacionMenuPaginas();
    }

    // #region Métodos de la clase

    /**
     * Comprueba si se cumplen las condiciones de equipo completo
     * @param pagina Página a la que se intenta ir
     * @param Identificador del equipo que deberá usarse en la siguiente página
     */
    private ComprobarEquipoCompleto(pagina: any, _idEquipo: number): void {
      let designacion: Proxy.PrDesignaciones =
        this.Persistentes.GetDesignacion();
      let idEquipo: number = this.Persistentes.GetIdEquipo();
      // Para la página de alineaciones, antes que pasar a una nueva, hay que comprobar si se cumplen las condiciones de la alineación.
      let participantes: Proxy.ListaPrParticipacion =
        new Proxy.ListaPrParticipacion(
          this.CFutbolActas,
          this.DBService2,
          this.Persistentes,
          this.toastCtrl,
          designacion,
          idEquipo
        );
      let tieneArchivoAlineacion: boolean = designacion.sinHojaAlineacion
        ? true
        : false;

      this.CFutbolActas.archivoAlineacion(
        designacion.urlApi,
        designacion.idDesignacion,
        idEquipo
      )
        .then((resultado: Online.IActa_Archivos_Alineaciones) => {
          if (resultado.idArchivo > 0) {
            tieneArchivoAlineacion = true;
          }
          return participantes.CargarListaParticipacion();
        })
        .then((resultado: boolean) => {
          // Se comprueba si tiene algún participante, para tenerlo en cuenta respecto a las hojas de alineación
          if (
            participantes.lista == undefined ||
            participantes.lista.length == 0 ||
            participantes.lista.filter((m) => m.esTitular || m.esSuplente)
              .length == 0
          ) {
            tieneArchivoAlineacion = true;
          }

          if (
            participantes.CumpleCondicionesAlineacion().trim().length > 0 ||
            !tieneArchivoAlineacion
          ) {
            let condiciones: string =
              participantes.CumpleCondicionesAlineacion().trim().length > 0
                ? participantes.CumpleCondicionesAlineacion().trim()
                : "No se cumplen las condiciones para cambiar de página: No se ha incluido el archivo con la fotografía del formulario de alineaciones.";

            if (
              !tieneArchivoAlineacion &&
              participantes.CumpleCondicionesAlineacion().trim().length > 0
            ) {
              condiciones +=
                ". No se ha incluido el archivo con la fotografía del formulario de alineaciones.";
            }

            let action: ActionSheet = this.actionSheetCtrl.create({
              buttons: [
                {
                  text: "Seguir",
                  handler: () => {
                    this.Persistentes.SetIdEquipo(_idEquipo);

                    // Se comprueba si la custodia está activa, para enviar a la página de la custodia. En caso contrario, hay que presentar otro ActionSheet para confirmar a donde quiere ir el usuario
                    if (pagina == ResultadoPage) {
                      let actionResultado: ActionSheet =
                        this.actionSheetCtrl.create({
                          buttons: [
                            {
                              text: "Salir",
                              handler: () => {
                                designacion.OtrosDatos.urlApi =
                                  designacion.urlApi;
                                designacion.OtrosDatos.urlNombre =
                                  designacion.urlNombre;

                                // Se debe marcar las alineaciones como terminadas y se sale a la validación de la aplicación
                                designacion.OtrosDatos.alineacionesTerminadas =
                                  true;
                                designacion.OtrosDatos.Guardar();
                                this.Persistentes.SetDesignacion(designacion);

                                this.Persistentes.SetArbitro(null);
                                this.nav.setRoot(LoginPage);
                                return this.nav.first();
                              },
                            },
                            {
                              text: "Seguir con el resultado",
                              handler: () => {
                                designacion.OtrosDatos.urlApi =
                                  designacion.urlApi;
                                designacion.OtrosDatos.urlNombre =
                                  designacion.urlNombre;

                                // Se debe marcar las alineaciones como terminadas y se sale a la validación de la aplicación
                                designacion.OtrosDatos.alineacionesTerminadas =
                                  true;
                                designacion.OtrosDatos.Guardar();
                                this.Persistentes.SetDesignacion(designacion);

                                this.nav.push(pagina);
                              },
                            },
                            {
                              text: "Cancelar",
                              role: "cancel",
                            },
                          ],
                        });
                      actionResultado.present();
                    } else {
                      this.nav.push(pagina);
                    }
                  },
                },
                {
                  text: "Cancelar",
                  role: "cancel",
                },
              ],
              title: "No se cumplen las condiciones",
              subTitle: condiciones,
            });
            action.present();
          } else {
            this.Persistentes.SetIdEquipo(_idEquipo);
            this.nav.push(pagina);
          }
        });
    }

    /**
     * Crea la lista de páginas que se mostrarán en el menú desplegable derecho
     */
    public CreacionMenuPaginas(): void {
      let designacion: Proxy.PrDesignaciones =
        this.Persistentes.GetDesignacion();

      this.paginas = [];
      this.Persistentes.GetConfiguracion().then((resultado: iConfiguracion) => {
        if (this.EsPrimeraParte()) {
          // Primera parte del acta
          this.paginas.push({
            pagina: AlineacionPage,
            idEquipo: designacion.idLocal,
            titulo: "Equipo local",
          });
          this.paginas.push({
            pagina: AlineacionPage,
            idEquipo: designacion.idVisitante,
            titulo: "Equipo visitante",
          });
          if (resultado.custodia) {
            this.paginas.push({
              pagina: CustodiaPage,
              idEquipo: designacion.idLocal,
              titulo: "Custodia",
            });
          }
        } else {
          // Segunda parte del acta
          this.paginas.push({
            pagina: ResultadoPage,
            idEquipo: designacion.idLocal,
            titulo: "Resultado",
          });

          if (
            designacion.OtrosDatos.estadoProvisional.trim().toLowerCase() ==
            "disputado" ||
            designacion.OtrosDatos.estadoProvisional.trim().toLowerCase() ==
            "suspendido iniciado"
          ) {
            // Cambios o participación local
            if (
              designacion.Configuracion.esFutbolSala ||
              designacion.Configuracion.esFutbolPlaya ||
              designacion.Configuracion.obligadaParticipacion
            ) {
              this.paginas.push({
                pagina: ParticipacionPage,
                idEquipo: designacion.idLocal,
                titulo: "Participación local",
              });
            } else {
              this.paginas.push({
                pagina: CambiosPage,
                idEquipo: designacion.idLocal,
                titulo: "Cambios local",
              });
            }
            // Goles local
            this.paginas.push({
              pagina: GolesPage,
              idEquipo: designacion.idLocal,
              titulo: "Goles local",
            });
            // Amonestaciones local
            this.paginas.push({
              pagina: AmonestacionesPage,
              idEquipo: designacion.idLocal,
              titulo: "Amonestaciones local",
            });

            // Cambios o participación visitante
            if (
              designacion.Configuracion.esFutbolSala ||
              designacion.Configuracion.esFutbolPlaya ||
              designacion.Configuracion.obligadaParticipacion
            ) {
              this.paginas.push({
                pagina: ParticipacionPage,
                idEquipo: designacion.idVisitante,
                titulo: "Participación visitante",
              });
            } else {
              this.paginas.push({
                pagina: CambiosPage,
                idEquipo: designacion.idVisitante,
                titulo: "Cambios visitante",
              });
            }

            // Goles visitante
            this.paginas.push({
              pagina: GolesPage,
              idEquipo: designacion.idVisitante,
              titulo: "Goles visitante",
            });
            // Amonestaciones visitante
            this.paginas.push({
              pagina: AmonestacionesPage,
              idEquipo: designacion.idVisitante,
              titulo: "Amonestaciones visitante",
            });

            if (designacion.Configuracion.esFutbolSala) {
              // Quintetos finales
              this.paginas.push({
                pagina: QuintetoPage,
                idEquipo: designacion.idLocal,
                titulo: "Quintetos finales",
              });
              // Tiempos muertos
              this.paginas.push({
                pagina: TiempoMuertoPage,
                idEquipo: designacion.idLocal,
                titulo: "Tiempos muertos",
              });
            }

            // Incidencias y otras incidencias
            this.paginas.push({
              pagina: IncidenciasPage,
              idEquipo: designacion.idLocal,
              titulo: "Incidencias",
            });

            if (resultado.lesionados) {
              this.paginas.push({
                pagina: LesionadosPage,
                idEquipo: designacion.idLocal,
                titulo: "Lesionados"
              });
            }

            // Resumen del acta
            this.paginas.push({
              pagina: ResumenPage,
              idEquipo: designacion.idLocal,
              titulo: "Resumen local",
            });
            this.paginas.push({
              pagina: ResumenPage,
              idEquipo: designacion.idVisitante,
              titulo: "Resumen visitante",
            });

            // Finalizar
            this.paginas.push({
              pagina: FinalizarPage,
              idEquipo: designacion.idLocal,
              titulo: "Finalizar",
              final: true,
            });
          } else if (
            designacion.OtrosDatos.estadoProvisional.trim().toLowerCase() ==
            "suspendido no iniciado"
          ) {
            // Finalizar
            this.paginas.push({
              pagina: FinalizarPage,
              idEquipo: designacion.idLocal,
              titulo: "Finalizar",
              final: true,
            });
          }
        }
      });
    }

    /**
     * Indica si la página actual, pertenece a la primera parte de aplicación del acta.
     */
    public EsPrimeraParte(): boolean {
      let resultado: boolean = false;

      switch (this.nav.getActive().name) {
        case "AlineacionPage":
        case "JugadoresPage":
        case "EntrenadoresPage":
        case "AuxiliaresPage":
        case "CustodiaPage":
          resultado = true;
          break;
      }

      return resultado;
    }

    /**
     * Realiza los pasos necesarios para cambiar la página actual, por la página que se pasa como parámetro. Se comprueba el cumplimiento de condiciones extraordinarias.
     * @param pagina Opción del menú que se ha seleccionado
     */
    public IrA(pagina: iMenuDerechoNavegacion): void {
      let idEquipo: number = this.Persistentes.GetIdEquipo();

      console.log(
        "Navegación:IrA: Página actual: " +
        this.nav.getActive().name +
        ", idEquipo: " +
        idEquipo
      );
      console.log(
        "Navegacion:IrA: Página destino: " +
        pagina.titulo +
        " (" +
        pagina.pagina.name +
        "), idEquipo: " +
        pagina.idEquipo
      );

      // Comprobación de si se está en la misma página, para no cambiar de página
      if (
        this.nav.getActive().name == pagina.pagina.name &&
        pagina.idEquipo == idEquipo
      ) {
        let toast = this.toastCtrl.create({
          message: "No se puede cambiar a la misma página",
          duration: 2000,
        });
        toast.present();
      } else {
        switch (this.nav.getActive().name) {
          case "AlineacionPage":
          case "JugadoresPage":
          case "EntrenadoresPage":
          case "AuxiliaresPage":
            this.ComprobarEquipoCompleto(pagina.pagina, pagina.idEquipo);
            break;

          default:
            this.Persistentes.SetIdEquipo(pagina.idEquipo);
            if (pagina.esIncidencia == true) {
              this.nav.push(pagina.pagina, {
                esIncidencia: true,
              });
            } else {
              this.nav.push(pagina.pagina);
            }
            break;
        }
      }
    }

    /**
     * Comprueba a qué estado debería avanzar para la página actual y los datos de la designación actual. Devuelve una promesa con la página a la que debería ir la página
     */
    public Siguiente(): void {
      // Obtención de nuevo de la designación.
      let designacion: Proxy.PrDesignaciones =
        this.Persistentes.GetDesignacion();
      let idEquipo: number = this.Persistentes.GetIdEquipo();

      console.log(
        "Navegación:Siguiente: Página actual: " + this.nav.getActive().name
      );

      this.Persistentes.GetConfiguracion().then(
        (resultadoConfiguracion: iConfiguracion) => {
          switch (this.nav.getActive().name) {
            case "AlineacionPage":
            case "JugadoresPage":
            case "AuxiliaresPage":
            case "EntrenadoresPage":
              if (designacion.EquipoLocal(idEquipo)) {
                this.ComprobarEquipoCompleto(
                  AlineacionPage,
                  designacion.idVisitante
                );
              } else {
                if (resultadoConfiguracion.custodia) {
                  this.ComprobarEquipoCompleto(
                    CustodiaPage,
                    designacion.idLocal
                  );
                } else {
                  this.ComprobarEquipoCompleto(
                    ResultadoPage,
                    designacion.idLocal
                  );
                }
              }
              break;

            case "CustodiaPage":
              console.log(
                "Navegacion:Siguiente: Página destino: ResultadoPage"
              );
              break;

            case "CambiosPage":
            case "ParticipacionPage":
              this.nav.push(GolesPage, {
                idEquipo: idEquipo,
                titulo:
                  idEquipo == designacion.idLocal
                    ? "Goles local"
                    : "Goles visitante",
              });
              break;

            case "GolesPage":
              this.nav.push(AmonestacionesPage, {
                esIncidencia: false,
              });
              break;

            case "AmonestacionesPage":
              if (!this.Persistentes.GetEsIncidencias()) {
                // Amonestaciones
                if (
                  designacion.Configuracion.esFutbolSala ||
                  designacion.Configuracion.esFutbolPlaya ||
                  designacion.Configuracion.obligadaParticipacion
                ) {
                  if (idEquipo == designacion.idLocal) {
                    this.Persistentes.SetIdEquipo(designacion.idVisitante);
                    this.nav.push(ParticipacionPage);
                  } else {
                    if (designacion.Configuracion.esFutbolSala) {
                      this.nav.push(QuintetoPage);
                    } else {
                      this.nav.push(IncidenciasPage);
                    }
                  }
                } else {
                  if (idEquipo == designacion.idLocal) {
                    this.Persistentes.SetIdEquipo(designacion.idVisitante);
                    this.nav.push(CambiosPage);
                  } else {
                    this.nav.push(IncidenciasPage);
                  }
                }
              } else {
                // Incidencias
                if (designacion.EquipoLocal(idEquipo)) {
                  this.Persistentes.SetIdEquipo(designacion.idVisitante);
                  this.nav.push(AmonestacionesPage, {
                    esIncidencia: true,
                  });
                } else {
                  this.Persistentes.SetIdEquipo(designacion.idLocal);
                  this.nav.push(ResumenPage);
                }
              }
              break;

            case "QuintetoPage":
              this.nav.push(TiempoMuertoPage);
              break;

            case "TiempoMuertoPage":
              this.nav.push(IncidenciasPage);
              break;

            case "IncidenciasPage":
              this.Persistentes.SetIdEquipo(designacion.idLocal);

              if (resultadoConfiguracion.lesionados) {
                this.nav.push(LesionadosPage);
              } else {
                this.nav.push(ResumenPage);
              }

              break;

            case "LesionadosPage":
              this.Persistentes.SetIdEquipo(designacion.idLocal);
              this.nav.push(ResumenPage);
              break;

            case "ResumenPage":
              if (designacion.EquipoLocal(idEquipo)) {
                this.Persistentes.SetIdEquipo(designacion.idVisitante);
                this.nav.push(ResumenPage);
              } else {
                this.nav.push(FinalizarPage);
              }
              break;
          }
        }
      );
    }
    // #endregion
  }
}



// WEBPACK FOOTER //
// ./src/models/online/navegacion.ts